<div
  [formGroup]="form"
  class="flex justify-between gap-4 py-2 px-6 items-center"
>
  <mat-form-field class="input-tg mt-message-input w-4/12" appearance="outline">
    <mat-label>Tipo Exame</mat-label>
    <mat-select formControlName="typeExam">
      @for (type of listType; track type) {
        <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="input-tg mt-message-input w-5/12" appearance="outline">
    <mat-label>Nome</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <mat-form-field class="input-tg mt-message-input w-5/12" appearance="outline">
    <mat-label>Descrição</mat-label>
    <input matInput formControlName="description" />
  </mat-form-field>
  <button
    mat-flat-button
    class="btn-tg w-2/12"
    [disabled]="form.invalid || loading"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar
    }
  </button>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
